import { PunctualityReportCriteria } from '@src/main/modules/reports/shared/domain/report.interface';
import { format } from 'date-fns';

export function parsePunctualityReportCriteria(
  criteria: PunctualityReportCriteria,
): Record<string, string | number> {
  const params: Record<string, string | number> = {};

  if (criteria.offset !== undefined) params.offset = criteria.offset;
  if (criteria.limit !== undefined) params.limit = criteria.limit;
  if (criteria.sortField) params.sortField = criteria.sortField;
  if (criteria.sortOrder) params.sortOrder = criteria.sortOrder;

  if (criteria.employeeId) params.employeeId = criteria.employeeId;
  if (criteria.carrierCode) params.carrierCode = criteria.carrierCode;
  if (criteria.flightNumber) params.flightNumber = criteria.flightNumber;
  if (criteria.aircraftRegistration) params.aircraftRegistration = criteria.aircraftRegistration;
  if (criteria.airportFrom) params.airportFrom = criteria.airportFrom;
  if (criteria.airportTo) params.airportTo = criteria.airportTo;
  if (criteria.formType) params.formType = criteria.formType;

  if (criteria.flightSince) {
    params.flightSince = format(new Date(criteria.flightSince), 'yyyy-MM-dd');
  }
  if (criteria.flightUntil) {
    params.flightUntil = format(new Date(criteria.flightUntil), 'yyyy-MM-dd');
  }
  if (criteria.formUpdatedSince) {
    params.formUpdatedSince = criteria.formUpdatedSince;
  }
  if (criteria.formUpdatedUntil) {
    params.formUpdatedUntil = criteria.formUpdatedUntil;
  }

  return params;
}
